import * as React from 'react';
import { Button, Radio } from 'antd';

import { AdminTab } from './AdminTabs/AdminTab';
import { EditorTab } from './AdminTabs/EditorTab';
import { PoolRequestTab } from './AdminTabs/PoolRequestTab';
import { RoleRequirementsTab } from './AdminTabs/RoleRequirementsTab';

import AdminDispatcher from '../dispatchers/AdminDispatcher';
import EditorDispatcher from '../dispatchers/EditorDispatcher';
import RoleRequirementDispatcher from '../dispatchers/RoleRequirementDispatcher';
import { getAdmins, getEditors, getRoleRequirements } from '../PoolAPI';

interface AdminState {
  tab: string;
}

export class AdminView extends React.Component<{}, AdminState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      tab: 'requests',
    };

    const fetches = [
      {
        fetch: getAdmins,
        update: AdminDispatcher.handleUpdateAdmins,
      },
      {
        fetch: getEditors,
        update: EditorDispatcher.handleUpdateEditors,
      },
      {
        fetch: getRoleRequirements,
        update: RoleRequirementDispatcher.handleUpdateRoleRequirements,
      },
    ];

    Promise.all(
      fetches.map(async (f) => {
        const r = await f.fetch();
        if (r.status >= 400) {
          const text = await r.text();
          console.error(text);
          return;
        }

        const j = await r.json();
        const update = f.update as (a: any) => void; // tslint:disable-line
        update(j);
      })
    );
  }

  render() {
    const radioGroup = (
      <Radio.Group
        className="radio-group"
        value={this.state.tab}
        onChange={(e: any) => this.tabSelected(e)} // tslint:disable-line
      >
        <Radio.Button value="requests">New Request Form</Radio.Button>
        <Radio.Button value="pool-selections">Pool Selections</Radio.Button>
        <Radio.Button value="editors">Editors</Radio.Button>
        <Radio.Button value="role-requirements">Role Requirements</Radio.Button>
        <Radio.Button value="admins">Admins</Radio.Button>
      </Radio.Group>
    );

    let body = null;
    if (this.state.tab === 'requests') {
      body = <PoolRequestTab />;
    } else if (this.state.tab === 'admins') {
      body = <AdminTab />;
    } else if (this.state.tab === 'editors') {
      body = <EditorTab />;
    } else if (this.state.tab === 'pool-selections') {
      body = (
        <div>
          <Button
            type="primary"
            icon="download"
            size="large"
            href="/api/get_pool_submissions"
          >
            Download Pool Selections
          </Button>
        </div>
      );
    } else if (this.state.tab === 'role-requirements') {
      body = <RoleRequirementsTab />;
    } else {
      body = <div>{this.state.tab}</div>;
    }

    return (
      <span>
        {radioGroup}
        {body}
      </span>
    );
  }

  private tabSelected(e: Event) {
    const target = e.target! as any; // tslint:disable-line
    this.setState({
      tab: target.value,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminView.tsx